"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toNumber = _interopRequireDefault(require("lodash/toNumber"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _round2 = _interopRequireDefault(require("lodash/round"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var NumberUtil = /*#__PURE__*/function () {
  function NumberUtil() {
    _classCallCheck(this, NumberUtil);
  }

  _createClass(NumberUtil, null, [{
    key: "parse",
    value: function parse(stringOrNumber) {
      if (Array.isArray(stringOrNumber)) {
        return stringOrNumber.map(function (v) {
          return NumberUtil.parseNumber(v);
        });
      }

      return NumberUtil.parseNumber(stringOrNumber);
    }
  }, {
    key: "parseNumber",
    value: function parseNumber(stringOrNumber) {
      var value = (0, _toNumber.default)(stringOrNumber);

      if ((0, _isNumber.default)(value) && !isNaN(value)) {
        return value;
      }

      return undefined;
    }
  }, {
    key: "formattedNumber",
    value: function formattedNumber(stringOrNumber) {
      var minFraction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var value = (0, _toNumber.default)(stringOrNumber);

      if ((0, _isNumber.default)(value) && !isNaN(value)) {
        return value.toLocaleString(navigator.language, {
          minimumFractionDigits: minFraction
        });
      }

      return undefined;
    }
  }, {
    key: "round",
    value: function round(number) {
      var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
      return (0, _round2.default)(number, decimalPlaces);
    }
  }]);

  return NumberUtil;
}();

exports.default = NumberUtil;